exports.LANGUAGE = {
  en: 'English',
  'zh-cn': '',
  'zh-Hans': '',
  'zh-Hant': '繁體中文',
  'zh-tc': '',
  ja: '日本語',
  ko: ' 한국어',
  th: '',
  it: '',
  in: '',
  id: '',
  es: '',
  ru: '',
  de: '',
  fr: '',
  pt: 'PORTUGUÊS'
};
exports.LANGUAGE_NAME = {
  en: '英文',
  'zh-cn': '简体中文',
  'zh-Hans': '简体中文',
  'zh-Hant': '繁体中文',
  'zh-tc': '繁体中文',
  ja: '日语',
  ko: '韩语',
  th: '泰语',
  it: '意大利语',
  in: '印度尼西亚语',
  id: '印度尼西亚语',
  es: '西班牙',
  ru: '俄语',
  de: '德语',
  fr: '法语',
  pt: '葡萄牙语'
};
exports.XIGUA_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'zh-Hant',
  ja: 'ja',
  ko: 'ko',
  th: 'th',
  it: 'it',
  id: 'in',
  es: 'es',
  ru: 'ru',
  de: 'de',
  fr: 'fr',
  'zh-Hant': 'zh-Hant',
  in: 'in',
  pt: 'pt'
};

exports.ZT_LANGUAGE = {
  en: 'en',
  'zh-cn': 'zh-Hans',
  'zh-Hans': 'zh-Hans',
  'zh-tc': 'cht',
  ja: 'jp',
  ko: 'kor',
  th: 'th',
  it: 'it',
  id: 'id',
  es: 'spa',
  ru: 'ru',
  de: 'de',
  fr: 'fra',
  'zh-Hant': 'cht',
  in: 'id',
  pt: 'pt'
};

/**
 *
 * zho（简体中文）
 * eng（英文）
 * zho-tw（台湾）
 * zho-hk（香港）
 * udm（维吾尔语）
 * jpn（日文）
 * ind（印尼）
 * kor（韩语）
 * rus（俄语）
 * ara（阿拉伯语）
 * spa（西班牙语）
 * pon（巴西葡语）
 * por（欧洲葡语）
 * fra（法语）
 * deu（德语）
 * @type {{de: string, 'zh-HANT': string, ru: string, ko: string, th: string, ja: string, en: string, it: string, id: string, fr: string, es: string}}
 */
exports.GEETEST_LANGUAGE = {
  en: 'eng',
  'zh-cn': 'zho',
  'zh-Hans': 'zho',
  'zh-tc': 'zho-hk',
  ja: 'jpn',
  ko: 'kor',
  th: 'eng',
  it: 'eng',
  id: 'ind',
  es: 'spa',
  ru: 'rus',
  de: 'deu',
  fr: 'fra',
  'zh-Hant': 'zho-hk',
  in: 'ind',
  pt: 'por'
};

exports.TDK = {
  en: {
    title: 'Mecha BREAK Official Site — Sign Up for Closed Beta!',
    keywords: 'Mecha BREAK, Mecha BREAK Official Site, Mecha BREAK Beta Registration, Mech Game, Sci-Fi, Shooter',
    description:
      'Sign up for Closed Beta now! Get early access to the global launch of our new game mode, Mashmak. Squad up for some epic co-op action, beyond the usual PvP battles.'
  },
  ja: {
    title: '『Mecha BREAK』公式サイトクローズドβテスト募集中',
    keywords: 'Mecha BREAK, Mecha BREAK公式サイト,Mecha BREAK事前予約, メカゲーム, SFゲーム,シューティングゲーム',
    description: 'クローズドβテスト募集中！マシュマーク降下作戦世界初公開、PvPのほか、探索やチームを組み共に戦おう'
  },
  ko: {
    title: '<Mecha BREAK> 공식사이트 ㅡ 클로즈 베타 테스트 모집 중',
    keywords: 'Mecha BREAK, Mecha BREAK 공식사이트, Mecha BREAK 예약, 메카 게임, Sci-fi 게임, 슈팅 게임',
    description:
      // eslint-disable-next-line quotes
      '클로즈 베타 테스트 모집 중! 전 세계 최초로 매시마크 전투에 참여해 PVP 대전 이외의 색다른 전투를 체험해 보세요!'
  },
  'zh-Hant': {
    title: '《Mecha BREAK》官方網站 — 封閉Beta測試招募中',
    keywords: 'Mecha BREAK，Mecha BREAK官網，Mecha BREAK預約，機甲遊戲，科幻遊戲，射擊遊戲',
    description: '封閉Beta測試招募中！一同參與全球首次Mashmak降下作戰，探索除PvP對戰外的機甲團隊共鬥'
  },
  pt: {
    title: 'Site oficial do Mecha BREAK — Inscreva-se no beta fechado!',
    keywords: 'Mecha BREAK, site oficial do Mecha BREAK, inscrição no beta de Mecha BREAK, jogo de mecha, ficção científica, jogo de tiro',
    description:
      'Inscreva-se já no beta fechado! Tenha acesso antecipado ao lançamento global do novo modo de jogo Mashmak. Forme equipe para curtir uma ação cooperativa épica que supera as batalhas JxJ genéricas!'
  }
};

const pcTest = '//test-zt.xoyo.games/www.mechabreak.com/p/m/2024/03/15/dlc/';
const pcMaster = '//www.mechabreak.com/m/';
exports.PC_ADDRESS = {
  en: {
    testUrl: pcTest + 'en/',
    masterUrl: pcMaster + 'en/'
  },
  ja: {
    testUrl: pcTest + 'ja/',
    masterUrl: pcMaster + 'ja/'
  },
  ko: {
    testUrl: pcTest + 'ko/',
    masterUrl: pcMaster + 'ko/'
  },
  'zh-Hant': {
    testUrl: pcTest + 'zh-Hant/',
    masterUrl: pcMaster + 'zh-Hant/'
  },
  es: {
    testUrl: pcTest + 'es/',
    masterUrl: pcMaster + 'es/'
  },
  pt: {
    testUrl: pcTest + 'pt/',
    masterUrl: pcMaster + 'pt/'
  },
  de: {
    testUrl: pcTest + 'de/',
    masterUrl: pcMaster + 'de/'
  },
  fr: {
    testUrl: pcTest + 'fr/',
    masterUrl: pcMaster + 'fr/'
  },
  ru: {
    testUrl: pcTest + 'ru/',
    masterUrl: pcMaster + 'ru/'
  }
};

exports.PROTOCOL = {
  en: {
    appointment: '//www.mechabreak.com/show-1034-38-1.html',
    cookie: '//www.mechabreak.com/show-1031-35-1.html',
    privacy: '//www.mechabreak.com/show-1031-29-1.html',
    service: '//www.mechabreak.com/show-1031-33-1.html'
  },
  ja: {
    appointment: '//www.mechabreak.com/show-1031-41-1.html',
    cookie: '//www.mechabreak.com/show-1031-36-1.html',
    privacy: '//www.mechabreak.com/show-1031-28-1.html',
    service: '//www.mechabreak.com/show-1031-32-1.html'
  },
  ko: {
    appointment: '//www.mechabreak.com/show-1031-40-1.html',
    cookie: '//www.mechabreak.com/show-1031-37-1.html',
    privacy: '//www.mechabreak.com/show-1031-27-1.html',
    service: '//www.mechabreak.com/show-1031-31-1.html'
  },
  'zh-Hant': {
    appointment: '//www.mechabreak.com/show-1031-39-1.html',
    cookie: '//www.mechabreak.com/show-1031-34-1.html',
    privacy: '//www.mechabreak.com/show-1031-26-1.html',
    service: '//www.mechabreak.com/show-1031-30-1.html'
  },
  es: {
    appointment: '//www.mechabreak.com/show-1094-146-1.html',
    cookie: '//www.mechabreak.com/show-1094-147-1.html',
    privacy: '//www.mechabreak.com/show-1094-148-1.html',
    service: '//www.mechabreak.com/show-1094-149-1.html'
  },
  pt: {
    appointment: '//www.mechabreak.com/show-1095-153-1.html',
    cookie: '//www.mechabreak.com/show-1095-152-1.html',
    privacy: '//www.mechabreak.com/show-1095-151-1.html',
    service: '//www.mechabreak.com/show-1095-150-1.html'
  },
  de: {
    appointment: '//www.mechabreak.com/show-1096-157-1.html',
    cookie: '//www.mechabreak.com/show-1096-156-1.html',
    privacy: '//www.mechabreak.com/show-1096-155-1.html',
    service: '//www.mechabreak.com/show-1096-154-1.html'
  },
  fr: {
    appointment: '//www.mechabreak.com/show-1097-161-1.html',
    cookie: '//www.mechabreak.com/show-1097-160-1.html',
    privacy: '//www.mechabreak.com/show-1097-159-1.html',
    service: '//www.mechabreak.com/show-1097-158-1.html'
  },
  ru: {
    appointment: '//www.mechabreak.com/show-1098-165-1.html',
    cookie: '//www.mechabreak.com/show-1098-164-1.html',
    privacy: '//www.mechabreak.com/show-1098-163-1.html',
    service: '//www.mechabreak.com/show-1098-162-1.html'
  }
};
